import {
  Component,
  input,
  model,
  computed,
  output,
  signal,
} from "@angular/core";
import { DialogModule } from "primeng/dialog";
import { ButtonModule } from "primeng/button";
import { TagModule } from "primeng/tag";
import { DividerModule } from "primeng/divider";
import { CardModule } from "primeng/card";
import { ChipModule } from "primeng/chip";
import { DatePipe } from "@angular/common";
import {AccordionPanel, AccordionHeader, AccordionContent, Accordion } from 'primeng/accordion';
import { ILogApiItem } from "../../../../../Utils/_services/logger/logger.model";


@Component({
  selector: "app-log-details-modal",
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
    TagModule,
    DividerModule,
    CardModule,
    ChipModule,
    DatePipe,
    AccordionPanel,
    AccordionHeader,
    AccordionContent,
    Accordion
],
  templateUrl: "./log-details-modal.component.html",
  styleUrl: "./log-details-modal.component.css",
})
export class LogDetailsModalComponent {
  log = input<ILogApiItem>();
  visible = model<boolean>(false);
  onClose = output();
  logIcon = computed(() => {
    const level = this.log()?.level;
    const iconMap: Record<string, string> = {
      error: "pi pi-times-circle text-red-500",
      warn: "pi pi-exclamation-triangle text-yellow-500",
      info: "pi pi-info-circle text-blue-500",
      debug: "pi pi-code text-purple-500",
    };
    return iconMap[level || "info"];
  });

  getLevelSeverity(level: string): string {
    const severityMap: Record<string, string> = {
      error: "p-tag-danger",
      warn: "p-tag-warning",
      info: "p-tag-info",
      debug: "p-tag-secondary",
    };

    return severityMap[level.toLowerCase()] || "p-tag-info";
  }

  getMessageBoxClass(level: string): string {
    return level.toLowerCase();
  }

  getLevelIcon(level: string): string {
    const iconMap: Record<string, string> = {
      error: "pi pi-times-circle text-red-500",
      warn: "pi pi-exclamation-triangle text-yellow-500",
      info: "pi pi-info-circle text-blue-500",
      debug: "pi pi-code text-purple-500",
    };
    return iconMap[level] || "pi pi-info-circle";
  }

  getMethodSeverity(method: string): string {
    const severityMap: Record<string, string> = {
      GET: "p-tag-info",
      POST: "p-tag-success",
      PUT: "p-tag-warning",
      PATCH: "p-tag-warning",
      DELETE: "p-tag-danger",
    };

    return severityMap[method.toUpperCase()] || "p-tag-secondary";
  }

  getRelativeTime(timestamp: Date): string {
    const now = new Date();
    const logTime = new Date(timestamp);
    const diffMs = now.getTime() - logTime.getTime();

    const diffSeconds = Math.floor(diffMs / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffSeconds < 60) return `${diffSeconds} seconds ago`;
    if (diffMinutes < 60) return `${diffMinutes} minutes ago`;
    if (diffHours < 24) return `${diffHours} hours ago`;
    if (diffDays < 30) return `${diffDays} days ago`;

    return logTime.toLocaleDateString();
  }

  closeDialog(): void {
    this.onClose.emit();
  }
}
